export const getErrorFields = (error: unknown): Record<string, unknown> => {
  if (typeof error !== 'object' || error === null || !('response' in error)) {
    return {};
  }
  const { response } = error;
  if (typeof response !== 'object' || response === null || !('data' in response)) {
    return {};
  }
  const { data } = response;
  if (typeof data !== 'object' || data === null || !('fields' in data)) {
    return {};
  }
  const { fields } = data;
  if (typeof fields !== 'object' || fields === null) return {};
  return Object.fromEntries(Object.entries(fields));
};
